import axios from "axios";
import API_CONFIG from "../config/apiConfig";

const getToken = () => {
  const token = localStorage.getItem("token");
  // Validate token is not null, empty, or invalid strings
  if (
    !token ||
    token === "null" ||
    token === "undefined" ||
    token === "Bearer null"
  ) {
    console.log("🚫 Invalid token detected, clearing from localStorage");
    localStorage.removeItem("token");
    return null;
  }
  return token;
};

const setContentType = (config) => {
  if (config.data instanceof FormData) {
    // For FormData, completely remove Content-Type header
    // Let the browser set it automatically with the correct boundary
    // This prevents charset from being added
    delete config.headers["Content-Type"];
    delete config.headers["content-type"];
    // Explicitly set to undefined to prevent any default
    config.headers["Content-Type"] = undefined;
    // Use transformRequest to ensure proper FormData handling
    if (!config.transformRequest) {
      config.transformRequest = [(data, headers) => {
        if (data instanceof FormData) {
          // Remove Content-Type header completely
          if (headers) {
            delete headers["Content-Type"];
            delete headers["content-type"];
          }
          return data;
        }
        return data;
      }];
    }
  } else {
    config.headers["Content-Type"] = "application/json";
  }
};

const axiosHandler = axios.create({
  baseURL: API_CONFIG.API_BASE_URL,
  timeout: 1000000,
});

axiosHandler.interceptors.request.use(
  (config) => {
    const token = getToken();
    console.log("🔐 Axios Request - Token:", token ? "Present" : "Missing");

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    } else {
      // Remove Authorization header if no token
      delete config.headers["Authorization"];
    }

    setContentType(config);
    return config;
  },
  (error) => {
    return Promise.reject(
      error instanceof Error ? error : new Error(String(error))
    );
  }
);

axiosHandler.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 403) {
      console.error("🚫 403 Forbidden - Token may be invalid or expired");
      // Optional: Redirect to login or handle token refresh
    }

    if (error.response) {
      console.error("API Error:", {
        status: error.response.status,
        data: error.response.data,
        url: error.config?.url,
      });
    } else if (error.request) {
      console.error("Network Error:", error.request);
    } else {
      console.error("Unknown Error:", error.message);
    }

    if (error instanceof Error) {
      return Promise.reject(error);
    } else {
      const err = new Error(error?.message || "Axios response error");
      Object.assign(err, error);
      return Promise.reject(err);
    }
  }
);

export default axiosHandler;
